import script from "./App.vue?vue&type=script&setup=true&name=app&lang=js"
export * from "./App.vue?vue&type=script&setup=true&name=app&lang=js"

const __exports__ = script;

export default __exports__